import { RootState } from '@store/store.interface';

const getState = (state: RootState) => state.inquiryResponse;
export const inquiryResponseDataSelector = (state: RootState) => getState(state).data;
export const printInquiryResponseDataSelector = (state: RootState) => getState(state).printData;
export const inquiryResponseIsLoadingSelector = (state: RootState) => getState(state).isLoading;
export const inquiryResponseErrorSelector = (state: RootState) => getState(state).error;
export const inquiryResponseActiveSupplementIdSelector = (state: RootState) =>
  getState(state).activeSupplementId;
export const inquiryResponseActiveSupplementDataSelector = (state: RootState) =>
  getState(state).activeSupplementData;
export const inquiryResponseActiveSupplementIsLoadingSelector = (state: RootState) =>
  getState(state).activeSupplementIsLoading;
export const inquiryResponseActiveSupplementErrorSelector = (state: RootState) =>
  getState(state).activeSupplementError;
export const inquiryResponseUserEnteredSupplementDataSelector = (state: RootState) =>
  getState(state).userEnteredSupplement;
export const inquiryResponseUserEnteredSupplementIsLoadingSelector = (state: RootState) =>
  getState(state).userEnteredSupplementIsLoading;
export const inquiryResponseUserEnteredSupplementErrorSelector = (state: RootState) =>
  getState(state).userEnteredSupplementError;
export const inquiryResponseShowRiskLevelDetailsSelector = (state: RootState) =>
  getState(state).showRiskLevelDetails;
